import * as actions from '../actions/actions'

const initialState = {
  error: '',
  isModalOpen:false,
  hasError:false,
  type:""
}

export default function error(state = initialState, action) {
  switch (action.type) {
    case actions.FETCH_ERROR_CLIENT:
      return fetchErrorClient(state, action)
    case actions.FETCH_ERROR_SERVER:
      return fetchErrorServer(state, action)
    case actions.TOGGLE_MODAL:
        return toggleModal(state,action)
    case actions.CLEAN_ERROR:
      return cleanError(state,action)
    default:
      return state
  }
}

const cleanError = (state, action) => {
  return initialState;
}

const fetchErrorClient = (state, action) => {
  return {
    ...state,
    error: action.error,
    hasError:true,
    type:"CLIENT",
    isModalOpen:true,
  }
}

const fetchErrorServer = (state, action) => {
  return {
    ...state,
    error: action.error,
    hasError:true,
    type:"SERVER",
    isModalOpen:true,
  }
}

const toggleModal = (state,action) => {
  // return {
  //   ...state,
  //   hasError:false,
  //   isModalOpen: !state.isModalOpen
  //
  // }
  return initialState;
}